import { yupResolver } from "@hookform/resolvers/yup";
import { ButtonSet, Form } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CancelButton from "../../components/Buttons/CancelButton";
import SubmitButton from "../../components/Buttons/SubmitButton";
import BusinessIdeaForm from "../../components/Forms/BusinessIdeaForm";
import BusinessProfileForm from "../../components/Forms/BusinessProfileForm";
import CompetitorDataForm from "../../components/Forms/CompetitorDataForm";
import ExecutiveSummaryForm from "../../components/Forms/ExecutiveSummaryForm";
import Card from "../../components/Card/Card";
import { basicApplicationSchema } from "../../services/SchemaService";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../http-common";
import { Tabs } from "carbon-components-react";
import { Tab } from "carbon-components-react";
import { Button } from "carbon-components-react";
import { ArrowRight20 } from "@carbon/icons-react";
import { ArrowLeft20 } from "@carbon/icons-react";
import ApplicationFillingInstructions from "../../components/Miscellaneous/ApplicationFillingInstructions";

const AddApplicationPage = () => {
  const [hasBusinessCurrently, setHasBusinessCurrently] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const { user, isCompetitor } = useAuth();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(basicApplicationSchema),
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    try {
      const response = await http.post("/applications", data);
      toast.success("Candidatura Registada com sucesso");
      navigate("../candidatura/" + response.data.uuid);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {
    if (isCompetitor) {
      setValue("firstName", user.firstName);
      setValue("lastName", user.lastName);
      setValue("phoneNumber1", user.username);
    }
  }, []);

  const nextTab = () => {
    setActiveTab((prev) => prev + 1);
  };
  const previousTab = () => {
    setActiveTab((prev) => prev - 1);
  };

  return (
    <Card title="Registar Candidatura">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Tabs
          scrollIntoView={false}
          selected={activeTab}
          type={"container"}
          onSelectionChange={(e) => setActiveTab(e)}
        >
          <Tab href="#" id="tab-0" label="INSTRUÇÕES">
            <ApplicationFillingInstructions />
            <div className="tab-navigation">
              <p></p>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-1" label="SECÇÃO A">
            <CompetitorDataForm
              register={register}
              control={control}
              errors={errors}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-2" label="SECÇÃO B">
            <ExecutiveSummaryForm
              register={register}
              errors={errors}
              setHasBusinessCurrently={setHasBusinessCurrently}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          {hasBusinessCurrently !== null && hasBusinessCurrently === "Sim" && (
            <Tab href="#" id="tab-3" label="SECÇÃO C">
              <BusinessProfileForm
                register={register}
                control={control}
                errors={errors}
              />
              <div className="tab-navigation">
                <Button kind="ghost" size="sm" onClick={previousTab}>
                  <ArrowLeft20 /> Anterior
                </Button>
                <Button kind="ghost" size="sm" onClick={nextTab}>
                  Próximo <ArrowRight20 />
                </Button>
              </div>
            </Tab>
          )}
          <Tab href="#" id="tab-4" label="SECÇÃO D">
            <BusinessIdeaForm register={register} errors={errors} />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
            </div>
          </Tab>
        </Tabs>
        <ButtonSet>
          <SubmitButton />
          <CancelButton />
        </ButtonSet>
      </Form>
    </Card>
  );
};

export default AddApplicationPage;
